module.exports = __webpack_public_path__ + "static/media/r.c957a7b8.jpg";